import axios from "axios";

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("al_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
};

export const capi = axios.create({ baseURL: "/api" });

capi.interceptors.request.use((config) => {
  const token = localStorage.getItem("alc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getCustomerProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("alc_profile"));
  } catch {
    return null;
  }
};

export const setCustomerSession = (token, customer) => {
  localStorage.setItem("alc_token", token);
  localStorage.setItem("alc_profile", JSON.stringify(customer));
};

export const clearCustomerSession = () => {
  localStorage.removeItem("alc_token");
  localStorage.removeItem("alc_profile");
};

export default api;
